export class Equipment {
  public Id: number;
  public Equipment: string = '';
  public Description: string = '';

  constructor() {}
}
